<template>
    <div>
        <base-input v-model="form.name" validate="required" label="Name" name="name"/>
        <base-text-area v-model="form.description" label="Description" name="description"/>
        <base-color-picker v-model="form.color"/><br/>

        <base-button
            :loading="loading"
            @click="submit"
            class="is-primary"
            icon="fas fa-check"
            text="Save"/>&nbsp;

        <base-button
            @click="$emit('cancel')"
            class="is-danger"
            icon="fas fa-times"
            text="Cancel"/>
    </div>
</template>

<script>
import { copy } from '../../utils/helpers';

export default {
    props: {
        loading: { type: Boolean },
        init_data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: {
                name: '',
                color: '',
                description: '',
                ...this.init_data,
            },
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', copy(this.form));
                this.form.name = '';
            });
        },
    },
};
</script>
